import lang from '@js/plugins/lang';

export default {
    methods: {
        choice(key, number, replacements, locale) {
            return lang.choice(key, number, replacements, locale);
        },

        trans(key, replacement) {
            return lang.trans(key, replacement);
        },
    },
};
